var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_Artikel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Artikel_Artikel",
    transform: "translate(-531.000000, -110.000000)",
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Produktname_001",
    transform: "translate(330.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(201.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.98030588,
    cy: 1.94823529,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.2,
    cx: 4.63214118,
    cy: 3.36790588,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.9s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.3,
    cx: 1.94865882,
    cy: 7.07230588,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.8s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.4,
    cx: 1.95522353,
    cy: 11.6466353,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.7s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.5,
    cx: 4.64929412,
    cy: 15.3434118,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.6s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.6,
    cx: 9.00148235,
    cy: 16.7505882,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.5s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.7,
    cx: 13.3498588,
    cy: 15.3309176,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.4s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.8,
    cx: 16.0331294,
    cy: 11.6265176,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.3s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    opacity: 0.9,
    cx: 16.0265647,
    cy: 7.05218824,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.2s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 13.3327059,
    cy: 3.35541176,
    r: 1.94823529
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0.1s",
    values: "1; 0.2;",
    dur: "1s",
    repeatCount: "indefinite"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.32ee0c9ea895e63427ea36b90f1cfd24.svg";
export { ForwardRef as ReactComponent };